var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-page"},[_c('Header',{attrs:{"title":_vm.$t('member.my_promotion_code')}}),_c('div',{staticClass:"invite-box"},[_c('div',{staticClass:"invite-qrcode"},[_c('QRCode',{ref:"qrcode"})],1),_c('p',[_vm._v(_vm._s(_vm.$t('member.promotion_code'))+" "+_vm._s(_vm.invite))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }